import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import ServiceOnboarding from '../services/ServiceOnboarding';

function Sidenavbar() {
    const profile = JSON.parse(localStorage.getItem('Profile') || '{}');
    const portalIndex = Number(localStorage.getItem('selectedPortalIndex')) || 0;
    const activePortal = profile.portals?.[portalIndex] || profile.portals?.[0] || {};
    // Permissions belong to the active workspace membership, not the global
    // tbl_Users account type. This matches the legacy AllowAnalytics rule.
    const rawRole = activePortal.role || localStorage.getItem('UserRole') || 'Member';
    const isAdmin = String(rawRole).toLowerCase() === 'admin';
    const canViewAnalytics = activePortal.allowAnalytics === true || isAdmin;

    const [Modules, setModules] = useState([]);
    const [activeMenu, setActiveMenu] = useState("");
    const apifunction = new ServiceOnboarding();
    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location.pathname.replace(/\/$/, "");

    useEffect(() => {
        if (!localStorage.getItem('UserID')) {
            localStorage.clear();
            navigate("/login");
        } else {
            if (pathname.match(/project/)) setActiveMenu("project");
            else if (pathname === "/") setActiveMenu("tasks");
            else if (pathname.match(/tasks/)) setActiveMenu("tasks");
            else if (pathname.match(/teams/)) setActiveMenu("teams");
            else if (pathname.match(/meetings/)) setActiveMenu("meetings");
            else if (pathname.match(/analytics/) || pathname.match(/engagement/)) {
                setActiveMenu("analytics");
            }
            else if (pathname.match('settings/profile-setting') || pathname.match('settings/subscription')) {
                setActiveMenu("profile-setting");
            }
            else if (pathname.match(/project-tasks/)) setActiveMenu("projects");
        }
    }, [pathname, navigate]);

    useEffect(() => {
        const loadData = async () => {
            await loadModules();
        };
        loadData();
    }, [pathname]);

    useEffect(() => {
        if (Modules.length > 0) {
            const checkIfDataAvailable = (module_name) => {
                return Modules.some(item => item.module_name === module_name);
            };

            if (pathname === "/project/all" && !checkIfDataAvailable("Projects")) {
                navigate("/please-upgrade-plan");
            } else if (pathname === "/analytics" && !checkIfDataAvailable("Performance Analytics")) {
                navigate("/please-upgrade-plan");
            } else if (pathname.match("/engagement/") && !checkIfDataAvailable("Engagement Analytics")) {
                navigate("/please-upgrade-plan");
            }
        }
    }, [pathname, Modules, navigate]);

    const loadModules = async () => {
        try {
            const req = {
                Email: localStorage.getItem("Email")
            };

            const result = await apifunction.UserProfile(req);
            if (result) {
                const PORTALS_LENGTH = Number(localStorage.getItem("PORTALS_LENGTH")) || 0;
                let selectedPortalIndex = 0;
                if (PORTALS_LENGTH > 1) {
                    selectedPortalIndex = Number(localStorage.getItem("selectedPortalIndex")) || 0;
                }
                const selectedPortal = result.portals?.[selectedPortalIndex] || result.portals?.[0];
                
                if (selectedPortal) {
                    localStorage.setItem("Totalmembers", selectedPortal.totalMembers || 0);
                    localStorage.setItem("offsettolocal", selectedPortal.offsettolocal || 0);
                    localStorage.setItem("registerdMembers", selectedPortal.registerdMembers || 0);
                    localStorage.setItem("teams", selectedPortal.teams || 0);
                    localStorage.setItem("answeredQuestions", selectedPortal.answeredQuestions || 0);
                    localStorage.setItem("tasks", selectedPortal.tasks || 0);
                }

                const modulesList = selectedPortal?.plan?.modules;
                if (Array.isArray(modulesList) && modulesList.length > 0) {
                    setModules(modulesList);
                } else {
                    toast.error("You don't have permissions to access any module. Please contact admin.");
                    setTimeout(() => {
                        localStorage.clear();
                        navigate("/login");
                    }, 1000);
                }
            }
        } catch (error) {
            toast.error('Failed to load modules. Please try again later.');
        }
    };

    return (
        <div className="fiexdsidenav" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
            <div className="logo" onClick={() => navigate("/")}>
                <img alt="image" src="/images/icons-v2/uniteam-Icon-white.svg" className="inner-logo" />
            </div>
            <div className="menu-list">
                {Modules && Modules.length > 0 ? Modules.map((item, index) => (
                    <div key={index}>
                        {item.module_name === "Tasks" && (
                            <Link id={index} className={activeMenu === "tasks" ? "active" : ""} to="/tasks">
                                <img alt="" src="/images/icons-v2/sidebar-tasks2.svg" className="menu-icon" />Tasks
                            </Link>
                        )}
                        {item.module_name === "Meetings" && (
                            <Link id={index} className={activeMenu === "meetings" ? "active" : ""} to="/meetings">
                                <img alt="" src="/images/icons-v2/sidebar-meetings2.svg" className="menu-icon" />Meetings
                            </Link>
                        )}
                        {item.module_name === "Teams" && (
                            <Link id={index} className={activeMenu === "teams" ? "active" : ""} to={`/teams`}>
                                <img alt="" src="/images/icons-v2/sidebar-teams2.svg" className="menu-icon" />Teams
                            </Link>
                        )}
                        {item.module_name === "Projects" && (
                            <Link id={index} className={activeMenu === "project" ? "active" : ""} to={`/project`}>
                                <img alt="" src="/images/icons-v2/sidebar-project.svg" className="menu-icon" />Projects
                            </Link>
                        )}
                        {item.module_name === "Performance Analytics" && canViewAnalytics && (
                            <Link id={index} className={activeMenu === "analytics" ? "active" : ""} to="/analytics">
                                <img alt="" src="/images/icons-v2/sidebar-analytics2.svg" className="menu-icon" />Analytics
                            </Link>
                        )}
                        {item.module_name === "Engagement Analytics" && isAdmin && (
                            <Link id={index} className={activeMenu === "profile-setting" ? "active" : ""} to="/settings/subscription">
                                <img alt="" src="/images/icons-v2/settings-sliders2.svg" className="menu-icon" />
                                Settings
                            </Link>
                        )}
                    </div>
                )) : (
                    <>
                        <Link to="/tasks" className={activeMenu === "tasks" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/sidebar-tasks2.svg" className="menu-icon" />Tasks
                        </Link>
                        <Link to="/meetings" className={activeMenu === "meetings" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/sidebar-meetings2.svg" className="menu-icon" />Meetings
                        </Link>
                        <Link to={`/teams`} className={activeMenu === "teams" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/sidebar-teams2.svg" className="menu-icon" style={{ width: "22px" }} />Teams
                        </Link>
                        <Link to={`/project`} className={activeMenu === "project" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/sidebar-project.svg" className="menu-icon" style={{ width: "22px" }} />Projects
                        </Link>
                        {canViewAnalytics && <Link to="/analytics" className={activeMenu === "analytics" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/sidebar-analytics2.svg" className="menu-icon" style={{ width: "22px" }} />Analytics
                        </Link>}
                        {isAdmin && <Link to="/settings/subscription" className={activeMenu === "profile-setting" ? "active" : ""}>
                            <img alt="" src="/images/icons-v2/settings-sliders2.svg" className="menu-icon" style={{ width: "22px" }} />
                            Settings
                        </Link>}
                    </>
                )}
            </div>
        </div>
    );
}

export default React.memo(Sidenavbar);
